// Copyright (c) 2025 Audere, All Rights Reserved

import { createTheme } from "@mui/material";

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    errorBody: true;
    body1bold: true;
    body2bold: true;
  }
}

interface ExtendedTypographyOptions {
  errorBody: React.CSSProperties;
  body1bold: React.CSSProperties;
  body2bold: React.CSSProperties;
}

declare module "@mui/material/styles" {
  interface Palette {
    detailBackground: Palette["primary"];
    imageBackground: Palette["primary"];
    secondaryBackground: Palette["primary"];
    custom: Palette["primary"];
    successBackground: Palette["primary"];
    infoBanner: Palette["primary"];
  }

  interface PaletteOptions {
    detailBackground?: PaletteOptions["primary"];
    imageBackground?: PaletteOptions["primary"];
    secondaryBackground?: PaletteOptions["primary"];
    custom?: PaletteOptions["primary"];
    successBackground?: PaletteOptions["primary"];
    infoBanner?: PaletteOptions["primary"];
  }
}
export const initTheme = createTheme({
  palette: {
    primary: {
      main: "#076BA8",
    },
    detailBackground: {
      main: "#f3f8fb",
    },
    imageBackground: {
      main: "#eaf1f8",
    },
    secondaryBackground: {
      main: "#0072c6",
    },
    custom: {
      main: "#333333",
    },
    successBackground: {
      main: "#EAF8E1",
    },
    infoBanner: {
      main: "#DE505066",
      dark: "#7C1717",
    },
  },
});

export const theme = createTheme(initTheme, {
  typography: {
    errorBody: {
      ...initTheme.typography.subtitle1,
      color: initTheme.palette.error.main,
    },
    body1bold: {
      ...initTheme.typography.body1,
      fontWeight: 500,
    },
    body2bold: {
      ...initTheme.typography.body2,
      fontWeight: 500,
    },
  } as ExtendedTypographyOptions,
});
